<template>
    <div>
        <Breadcrumbs :type="type" :header="title" :url="url"></Breadcrumbs>
        <div class="max-w-5xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="store">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/1"
                        label="Name" required="true" placeholder="i.e sign up" />
                    <text-input v-model="form.slug" :error="form.errors.slug" class="pb-8 pr-6 w-full lg:w-1/1"
                        label="Slug" required="true" placeholder="i.e sign-up" />

                    <text-input v-model="form.email_subject" :error="form.errors.email_subject"
                        class="pb-8 pr-6 w-full lg:w-1/1" label="Subject" required="true" placeholder="i.e " />
                    <textarea-input v-model="form.email_body" :error="form.errors.email_body"
                        class="pb-8 pr-6 w-full lg:w-1/1" label="Body" required="true" placeholder="i.e " />

                    <status-toogle-button v-model="form.status" :error="form.errors.status" label="Status"
                        class="pb-8 pr-6 w-full lg:w-1/1"></status-toogle-button>
                </div>
                <Button :type="type" :name="title" :url="createUrl" :loading="form.processing"></Button>
            </form>
        </div>
    </div>
</template>

<script>
import Breadcrumbs from '@/Shared/Breadcrumbs'
import Button from '@/Shared/Button'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import StatusToogleButton from '@/Shared/StatusToogleButton'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import { ref, inject, toRefs } from 'vue'
import { Quill, VueEditor } from "vue3-editor"
export default {
    components: {
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TextareaInput,
        Breadcrumbs,
        StatusToogleButton,
        Button,
        Quill,
        VueEditor
    },
    layout: Layout,
    remember: 'form',
    setup() {
        const form = useForm({
            name: null,
            slug: null,
            email_subject: null,
            email_body: null,
            status: true
        })
        const type = ref('create')
        const title = ref('Email Template')
        const url = ref('/backend/email-templates')
        const createUrl = ref('')
        const swal = inject('$swal')
        const store = () => {
            swal({
                title: 'Are you sure?',
                text: "You want to proceed with this action",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
            }).then((result) => {
                if (result.isConfirmed) {
                    form.post(`${url.value}`, { forceFormData: true, })
                    swal.fire(
                        'Added!',
                        'Your infomation has been Added.',
                        'success'
                    )
                }
            });

        }
        return {
            form,
            type,
            title,
            url,
            createUrl,
            store
        }
    }
}
</script>
